import { render, staticRenderFns } from "./Trespasoscompleto.vue?vue&type=template&id=2f376cb2&scoped=true&"
import script from "./Trespasoscompleto.vue?vue&type=script&lang=js&"
export * from "./Trespasoscompleto.vue?vue&type=script&lang=js&"
import style0 from "./Trespasoscompleto.vue?vue&type=style&index=0&id=2f376cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f376cb2",
  null
  
)

export default component.exports